// 9fbef606107a605d69c0edbcd8029e5d
import { connect } from 'react-redux';
import { React, useEffect, useState } from 'react';
import {
  getAdyenSessionCacheTTL,
  getAdyenIntentValue,
  getIsDynamicFreeShippingEnabled,
  getIsSuppressApplePayEmailFieldEnabled,
  getIsOptimizeApplePaySheet,
  getAdyenApplePayCheckoutVisibility,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import { compose } from 'redux';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import CHECKOUT_ACTIONS, {
  submitBillingSection,
  setApplePaymentInProgress,
} from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.action';
import setLoaderState from '@tcp/core/src/components/common/molecules/Loader/container/Loader.actions';
import {
  getLedgerSummaryData,
  getApplePayDisc,
  getFinalPriceValue,
  getShippingTotal,
  getProductTotal,
} from '@tcp/core/src/components/features/CnC/common/organism/OrderLedger/container/orderLedger.selector';
import { SPC_SECTION } from '@tcp/core/src/components/features/CnC/SinglePageCheckout/container/SinglePageCheckout.constants';
import { getFreeShippingThresholdValue } from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import { isRememberedUser } from '@tcp/core/src/components/features/account/User/container/User.selectors.js';
import AdyenPaymentView from '../views/AdyenPayment.view';
import { getGrandTotal } from '../../../../features/CnC/AddedToBag/container/AddedToBag.selectors';
import BagPageSelectors, {
  getOrderType,
} from '../../../../features/CnC/BagPage/container/BagPage.selectors';
import { getAdyenSessionData, getAdyenSetupData } from './AdyenPayment.selector';
import {
  getPickupAltValues,
  getPickupValues,
  getUserContactInfo,
  isGuest as isGuestUser,
} from '../../../../features/CnC/Checkout/container/Checkout.selector';
import { getOrderShipments } from '../../../../features/CnC/CartItemTile/container/CartItemTile.selectors';
import {
  startAdyenPaymentAction,
  setAdyenSessionData,
  setAdyenSetupData,
  createAdyenSessionAction,
  startAdyenApplePayInventoryAction,
} from './AdyenPayment.actions';
import {
  getIsOosItem,
  getSinglePageCheckoutSectionState,
} from '../../../../features/CnC/SinglePageCheckout/container/SinglePageCheckout.selector';
import { submitReviewSection } from '../../../../features/CnC/Checkout/container/Checkout.action';
import GlobalErrorComponentReducer from '../../../molecules/GlobalErrorComponent/container/GlobalErrorComponent.reducer';
import { AddToCartError } from '../../../../features/CnC/AddedToBag/container/AddedToBag.actions';
import { setIsMixedPaymentWithPaypal } from '../../../../features/CnC/BagPage/container/BagPage.actions';
import { getContactFormValuesFromSS } from '../../../../features/CnC/SinglePageCheckout/molecules/ContactForm/ContactForm.util';

const AdyenPaymentContainer = (props) => {
  const {
    createAdyenSession,
    adyenSessionData,
    adyenSessionCacheTTL,
    isBagPage,
    setServerErrorCheckoutAction,
    setAddToCartError,
    emailAddressFromSS,
    rememberedUserFlag,
    isGuest,
    isSuppressApplePayEmailFieldEnabled,
    stores,
    isOptimizeApplePaySheetEnabled,
  } = props;
  const [renderFlag, setrenderFlag] = useState(true);
  const [paypalToBeSelected, setPaypalToBeSelected] = useState(false);
  const suppressEmailField =
    (!isGuest || rememberedUserFlag) && isSuppressApplePayEmailFieldEnabled;

  useEffect(() => {
    setServerErrorCheckoutAction({});
    setAddToCartError(null);
    createAdyenSession({ isBagPage, cacheTTL: adyenSessionCacheTTL });
  }, []);

  const reloadDropinPaypal = () => {
    setrenderFlag(false);
    if (window?.AdyenPaypalInstance?.unmount) {
      window.AdyenPaypalInstance.unmount();
    }
    setTimeout(() => {
      setPaypalToBeSelected(true);
      setrenderFlag(true);
    }, 0);
  };

  const submitBillingApple = (payloadParam) => {
    const { submitBilling, setAppleProgress } = props;
    setAppleProgress(true);
    submitBilling(payloadParam);
  };
  let content = null;

  if (adyenSessionData && renderFlag) {
    content = (
      <AdyenPaymentView
        {...props}
        adyenSessionData={adyenSessionData}
        adyenSessionCacheTTL={adyenSessionCacheTTL}
        isBagPage={isBagPage}
        reloadDropinPaypal={reloadDropinPaypal}
        paypalToBeSelected={paypalToBeSelected}
        submitAppleBillingSection={submitBillingApple}
        emailAddressFromSS={emailAddressFromSS?.emailAddress}
        suppressEmailField={suppressEmailField}
        stores={stores}
        isOptimizeApplePaySheetEnabled={isOptimizeApplePaySheetEnabled}
      />
    );
  } else if (renderFlag) {
    content = <div className="paypal-adyen-container" />;
  }

  return content;
};

export const mapDispatchToProps = (dispatch) => {
  return {
    startAdyenPayment: (payload) => {
      return new Promise((resolve, reject) => {
        dispatch(startAdyenPaymentAction({ ...payload, resolve, reject }));
      });
    },
    startAdyenApplePayInventory: (payload) => {
      return new Promise((resolve, reject) => {
        dispatch(startAdyenApplePayInventoryAction({ ...payload, resolve, reject }));
      });
    },

    createAdyenSession: (payload) => {
      dispatch(createAdyenSessionAction(payload));
    },
    setAdyenSessionData: (payload) => {
      dispatch(setAdyenSessionData(payload));
    },
    setAdyenSetupData: (payload) => {
      dispatch(setAdyenSetupData(payload));
    },
    submitReview: (payload) => dispatch(submitReviewSection(payload)),
    setServerErrorCheckoutAction: (data) => dispatch(CHECKOUT_ACTIONS.setServerErrorCheckout(data)),
    paypalPaymentInProgressAction: (payload) =>
      dispatch(CHECKOUT_ACTIONS.setPaypalPaymentInProgress(payload)),
    setAddToCartError: (data) => dispatch(AddToCartError(data)),
    setLoaderStateAction: (payload) => dispatch(setLoaderState(payload)),
    setIsMixedPaymentWithPaypalAction: (payload) => dispatch(setIsMixedPaymentWithPaypal(payload)),
    submitBilling: (payload) => dispatch(submitBillingSection(payload)),
    setAppleProgress: (data) => dispatch(setApplePaymentInProgress(data)),
  };
};

const mapStateToProps = (state) => {
  const contactData = getSinglePageCheckoutSectionState()(state, SPC_SECTION.CONTACT);

  const pageLedgerSummaryData = getLedgerSummaryData(state);
  const applePayDisc = getApplePayDisc(state) || 0;
  const { couponsTotal = 0, orderBalanceTotal = 0 } = pageLedgerSummaryData;
  const { getCartStoresToJs } = BagPageSelectors;
  return {
    cartValue: getGrandTotal(state),
    finalPriceValue: getFinalPriceValue(state)?.formattedPriceValue,
    orderType: getOrderType(state),
    userBasketPickUpValues: getPickupValues(state),
    shipModeId: BagPageSelectors.getShippingModeID(state),
    shippingContact: BagPageSelectors.getShippingContactForApplePay(state),
    userBasketPickUpAlternatePerson: getPickupAltValues(state),
    shipments: getOrderShipments(state),
    isOosItem: getIsOosItem(state),
    adyenSessionData: getAdyenSessionData(state),
    adyenSetupData: getAdyenSetupData(state),
    adyenSessionCacheTTL: getAdyenSessionCacheTTL(state),
    adyenIntentValue: getAdyenIntentValue(state),
    pageLedgerSummaryData: {
      ...pageLedgerSummaryData,
      couponsTotal: couponsTotal + applePayDisc,
      orderBalanceTotal: orderBalanceTotal - applePayDisc,
    },
    userProfileInfo: getUserContactInfo(state),
    errorLabels: BagPageSelectors.getErrorMapping(state),
    emailAddressFromSS: getContactFormValuesFromSS(contactData),
    freeShippingThershold: getFreeShippingThresholdValue(state),
    shippingTotal: getShippingTotal(state),
    isDynamicFreeShippingEnabled: getIsDynamicFreeShippingEnabled(state),
    productTotal: getProductTotal(state),
    isSuppressApplePayEmailFieldEnabled: getIsSuppressApplePayEmailFieldEnabled(state),
    isGuest: isGuestUser(state),
    rememberedUserFlag: isRememberedUser(state),
    stores: getCartStoresToJs(state),
    isOptimizeApplePaySheetEnabled: getIsOptimizeApplePaySheet(state),
    isAdyenApplePayCheckoutVisibilityEnabled: getAdyenApplePayCheckoutVisibility(state),
  };
};

const withReducer = withDynamicReducer([
  { key: 'GlobalErrorComponent', reducer: GlobalErrorComponentReducer },
]);

export default compose(
  withReducer,
  connect(mapStateToProps, mapDispatchToProps)
)(AdyenPaymentContainer);
